import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/content/images/bike_master_dial_tire_pressure_gauge_detail.jpg")